import { AiOutlinePlusCircle } from 'react-icons/ai';
import { BsChevronRight } from 'react-icons/bs';
import { BiLocationPlus } from 'react-icons/bi';
import { TbReportMoney } from 'react-icons/tb';
import { IoMdCrop, IoMdTime } from 'react-icons/io';
import { BsHouseDoor } from 'react-icons/bs';
import { HiHeart } from 'react-icons/hi';
import { HiOutlineHeart } from 'react-icons/hi';
import { AiOutlineStar, AiOutlineArrowLeft } from 'react-icons/ai';
import { BsFillBookmarkStarFill, BsDot, BsTelephoneFill } from 'react-icons/bs';
import { GrFormNextLink, GrLinkPrevious } from 'react-icons/gr';
import { FaPencilAlt } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';
import { MdManageSearch, MdLocationOn } from 'react-icons/md';
import { BiLogOut } from 'react-icons/bi';
import { GrCircleInformation } from 'react-icons/gr';
import { FaCamera, FaHashtag } from 'react-icons/fa';
import { SiZalo } from 'react-icons/si';
const icons = {
    AiOutlinePlusCircle,
    BsChevronRight,
    BiLocationPlus,
    TbReportMoney,
    IoMdCrop,
    BsHouseDoor,
    HiHeart,
    HiOutlineHeart,
    AiOutlineStar,
    BsFillBookmarkStarFill,
    GrFormNextLink,
    GrLinkPrevious,
    AiOutlineArrowLeft,
    FaPencilAlt,
    IoIosArrowDown,
    MdManageSearch,
    BiLogOut,
    GrCircleInformation,
    FaCamera,
    MdLocationOn,
    IoMdTime,
    FaHashtag,
    BsDot,
    BsTelephoneFill,
    SiZalo,
};
export default icons;
